import { useReopenCbamReport } from '@/features/cbam-reporting/hooks/cbamReports'
import useI18n from '@/shared/hooks/usei18n'
import { useSession } from '@/shared/hooks/useSession'
import { Button, GenericDialog } from '@/common'
import { TriangleExclamationIcon } from '@/common/components/icons'
import toast from 'react-hot-toast'

export default function ReopenCbamReportDialog({
  isOpen,
  close,
  cbamReportId
}: {
  isOpen: boolean
  close: () => void
  cbamReportId: string
}) {
  const { t } = useI18n()
  const organizationId = useSession().session.organization.id

  const { mutateAsync: reopenCbamReport, isPending } = useReopenCbamReport(
    organizationId,
    cbamReportId
  )

  const onReopenCbamReport = async () => {
    try {
      await reopenCbamReport()
      toast.success(t('cbamReporting:cbamReportDetails.notification.reopenReportSuccess'), {
        position: 'top-right'
      })
      close()
    } catch {
      toast.error(t('cbamReporting:cbamReportDetails.notification.reopenReportError'), {
        position: 'top-right'
      })
    }
  }

  return (
    <GenericDialog
      isOpen={isOpen}
      close={close}
      title={t('cbamReporting:cbamReportDetails.reopenReportDialog.title')}
      size="lg"
      icon={<TriangleExclamationIcon className="size-6" />}
    >
      <div className="mb-6">
        <p>{t('cbamReporting:cbamReportDetails.reopenReportDialog.description')}</p>
      </div>
      <footer className="flex justify-end gap-2">
        <Button variant="neutral" onClick={close}>
          {t('common:actions.cancel')}
        </Button>
        <Button disabled={isPending} isLoading={isPending} onClick={onReopenCbamReport}>
          {t('common:actions.confirm')}
        </Button>
      </footer>
    </GenericDialog>
  )
}
